import {analytics} from '../services'
import {fetch as fetchRaw} from '@lib/fetch'
import {getDefinedUrlSearchParams} from '@lib/util'

const fetch = (url, ...args) => fetchRaw([analytics.url, url], ...args)

export const getTracingAnalytics = (companyId, queryParams) => {
  return fetch(`/v1/tracing-metrics/${companyId}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export const getTracingPoDocumentAnalytics = (companyId, queryParams) => {
  return fetch(`/v1/tracing-documents/completion/${companyId}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export const listTracingPoDocuments = (companyId, queryParams) => {
  return fetch(`/v1/tracing-documents/${companyId}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export const exportOperationalMetricsData = body => {
  return fetch(`/v1/tracing-metrics/export`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export const getCertificationsMetrics = (companyId, queryParams) => {
  return fetch(`/v1/certification-metrics/${companyId}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export const getCertificationsByStandardMetrics = (companyId, queryParams) => {
  return fetch(`/v1/certification-metrics/by-standard/${companyId}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export const getAuditsMetrics = (companyId, queryParams) => {
  return fetch(`/v1/audit-metrics/${companyId}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export const getAuditsMetricsByImpactAreas = (companyId, queryParams) => {
  return fetch(`/v1/audit-metrics/impact-areas/${companyId}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export const getAuditFindingsByUrgency = (companyId, queryParams) => {
  return fetch(`/v1/audit-metrics/urgencies/${companyId}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export const exportCertificateMetricsData = body => {
  return fetch(`/v1/certification-metrics/export`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}
